<template>
  <div>
    <navbar-main />
    <site-chooser />
    <div class="content-wrap">
      <div class="row">
        <div class="col-3">
          <sidebar-main />
        </div>
        <div class="col-9">
          <router-view :key="$route.fullPath" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarMain from '@/components/navbar/NavbarMain'
import SidebarMain from '@/components/sidebar/SidebarMain'
import SiteChooser from '@/components/SiteChooser'

export default {
  name: 'LayoutMain',
  components: {
    NavbarMain,
    SidebarMain,
    SiteChooser
  }
}
</script>

<style lang="scss">
  @import "~@/assets/scss/_variables.scss";
  @import "~bootstrap/scss/mixins/breakpoints";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";

  .content-wrap {
    margin-left: -15px;
    margin-right: 15px;
    .pre-loader {
      position: absolute;
      left: $vuestic-preloader-left;
      top: $vuestic-preloader-top;
    }

    .sidebar-hidden & {
      margin-left: $sidebar-left;
    }

    @include media-breakpoint-down(md) {
      padding: $content-mobile-wrap;
      margin-left: 0;

      .sidebar-hidden & {
        margin-left: 0;
      }
    }
  }
</style>
